import type { FC } from "react";
import { ClientPortfolioToolIdentificationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import type { NormalizedTool } from "web_myplann/Portfolio/Helpers/investmentToolTypes";

const ToolResources = Resources.PortfolioDetail.LifeInsurance.InvestmentTool;

type Props = {
	tool: NormalizedTool;
};

export const ToolIdentificationRow: FC<Props> = ({ tool }) => {
	const { t } = useResource();

	return (
		<DetailRow
			label={t(
				ToolResources.IdentificationType[
					tool.identificationType ??
						ClientPortfolioToolIdentificationTypeEnum.None
				],
			)}
			value={tool.identification}
		/>
	);
};
